import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import investorGoalsSelector from '../Helpers/InvestorGoalsSelector.js'
import { getRelativeBasePath } from '../../../global/environments/path.js'

function RelatedProducts({ relatedProducts }) {
  const investorGoalData = investorGoalsSelector(relatedProducts.investorGoal)

  return (
    <section
      className="section-content u-adel-reset"
      data-section-content="similar"
      id="similar"
    >
      <div className="u-sizeConstrained">
        <div id="related-products">
          <div className="u-paddingVert12gu">
            <h2 className="u-marginBottom6gu">Related Products</h2>
            <ul className="Grid Grid--alignMiddle Grid--fit u-marginBottom3gu u-textSizeMsrp1 u-textSecondary u-sm-flexCol u-sm-flexAlignItemsStart">
              {/* {investorGoalData.icon && investorGoalData.title && (
                <Fragment>
                  {investorGoalData.icon}
                  <li className="u-flex u-flexAlignItemsCenter u-marginRight0 u-textColorBrand">
                    <span className="u-textKernLoose u-textUppercase">
                      {investorGoalData.title}
                    </span>
                  </li>
                  <li className="u-paddingHoriz1gu u-textColorLight u-textSizeMsrm1 u-sm-hidden">
                    |
                  </li>
                </Fragment>
              )} */}
              <li>{investorGoalData.content}</li>
            </ul>
            {relatedProducts.funds.value && (
              <div className="Grid Grid--equalHeight Grid--withGutter u-sm-flexCol">
                {relatedProducts.funds.value.map((product) => {
                  // TODO: need to fill in wildcards with actual values; e.g.; investment-products/-/-/-/details?cusip=
                  const isEtfType = product.fundCategory === 'Retail ETF'
                  const productType = isEtfType
                    ? 'exchange-traded-funds'
                    : 'mutual-funds'
                  const productName = product.title.replace(/ /g, '-')
                  const productClass = isEtfType
                    ? product.symbol
                    : 'Class-Advisor'

                  return (
                    <div
                      className="u-size4of12 u-sm-marginBottom3gu u-sm-sizeFull"
                      key={product.cusip}
                    >
                      <a
                        className="Button Button--secondary u-padding3gu Button--block u-textNoTransform u-textLeft"
                        href={`${getRelativeBasePath()}/investment-products/${productType}/${productName}/${productClass}/details?cusip=${
                          product.cusip
                        }`}
                        target={`${isEtfType ? '_blank' : ''}`}
                      >
                        <Fragment>
                          {isEtfType ? (
                            <h4 className="u-textColorBrand">
                              <span className="u-textColorLight u-textKernLoose u-textNormal u-textSecondary u-textUppercase">
                                {product.symbol}
                              </span>{' '}
                              {product.title}
                            </h4>
                          ) : (
                            <h4 className="u-textColorBrand">
                              {product.title}
                              <span className="u-textColorLight u-textKernLoose u-textNormal u-textSecondary u-textUppercase">
                                {' '}
                                {product.symbol}
                              </span>
                            </h4>
                          )}
                        </Fragment>
                      </a>
                    </div>
                  )
                })}
              </div>
            )}
          </div>
        </div>
        <hr className="Rule Rule--thin Module-divider" role="presentation" />
      </div>
    </section>
  )
}

RelatedProducts.propTypes = {
  relatedProducts: PropTypes.object.isRequired,
}

export default RelatedProducts
